import { useState } from "react";

const ENDPOINT = process.env.REACT_APP_FORMSPREE_ENDPOINT;

export function useFormspree() {
  const [status, setStatus] = useState({ state: "idle", message: "" });

  async function submit(payload, formType) {
    if (status.state === "submitting") return false;
    setStatus({ state: "submitting", message: "Sending…" });

    const data = new FormData();
    Object.entries(payload).forEach(([key, value]) => data.append(key, value));
    data.append("form_type", formType);
    data.append("source_page", window.location.href);

    try {
      const response = await fetch(ENDPOINT, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: data,
      });

      let body = {};
      try {
        body = await response.json();
      } catch (_) {
        // Non-JSON failure response
      }

      if (!response.ok) {
        if (response.status === 429) {
          throw new Error("Too many attempts. Please wait a moment and try again.");
        }
        throw new Error(
          body?.errors?.map((e) => e.message).join(" ") ||
            body?.error ||
            `Submission failed (${response.status}). Please try again.`
        );
      }

      setStatus({
        state: "success",
        message: "Thank you! Your request has been sent successfully. Our team will contact you shortly.",
      });
      return true;
    } catch (error) {
      setStatus({
        state: "error",
        message:
          error.name === "TypeError"
            ? "Network error. Please check your connection and try again."
            : error.message,
      });
      return false;
    }
  }

  function reset() {
    setStatus({ state: "idle", message: "" });
  }

  return { status, submit, reset };
}
